module.exports = "<uib-progress max=\"vm.sidebar.maxCountByTypePreview[vm.type] || vm.sidebar.maxCountByType[vm.type] || 1\">\n  <uib-bar value=\"vm.getPrev()\" type=\"info\"></uib-bar>\n  <uib-bar value=\"vm.getCount()\" type=\"success\"></uib-bar>\n</uib-progress>\n<div class=\"menu-text\">\n  <span>\n    {{vm.item.name}}\n    <small ng-if=\"!vm.sidebar.preSelectShow\">( {{vm.count}} )</small>\n    <small ng-if=\"vm.sidebar.preSelectShow\">( {{vm.preSelectCount}} )</small>\n    <small>( {{vm.getPercent() | number:2}} % )</small>\n  </span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/sidebar/menuItem/menuItem.html
// module id = 545
// module chunks = 0